import React, { useState } from "react";
import { Upload, message } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { uploadBackgroundPictureToAWS } from "../../utils/appearance";

const UploadBackgroundImage = ({ pageDetails, refreshContextProvider }) => {
  console.log(pageDetails);
  const [loadingImage, setLoadingImage] = useState(false);
  const [bgImage, setBgImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handleChange = async ({ file, fileList }) => {
    // setFileList(fileList);
    if (!file.status) {
      file.status = "error";
      setFileList([file]);
    } else {
      setFileList(fileList);
    }
    if (fileList.length === 0) {
      // setImageUrl();
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    try {
      const fmData = new FormData();
      fmData.append("image", file);
      setLoadingImage(true);
      let imageUrl = await uploadBackgroundPictureToAWS(
        fmData,
        pageDetails.PageID,
        pageDetails.BackgroundImage
      );
      if (imageUrl) {
        setBgImage(imageUrl.imageUrl);
        onSuccess("Ok");
        refreshContextProvider();
      } else {
        setBgImage();
      }
    } catch (err) {
      console.log("Error: ", err);
      new Error("Some error");
      onError({ err });
    } finally {
      setLoadingImage(false);
    }
  };

  const handleBeforeUpload = (file) => {
    const isSmallerThan2Mb = file.size / 1024 / 1024 < 2;
    if (!isSmallerThan2Mb) {
      message.error(
        "Votre image ne doit pas dépasser 2 Mo pour des raisons de performance."
      );
      return false;
    } else {
      return true;
    }
  };

  const showUploadList = {
    showDownloadIcon: false,
    showRemoveIcon: false,
    showUploadList: false,
  };

  return (
    <div style={{ width: "40%", marginTop: "10px" }}>
      {" "}
      <Upload
        fileList={fileList}
        customRequest={uploadImage}
        showUploadList={showUploadList}
        onChange={handleChange}
        beforeUpload={handleBeforeUpload}
        accept=".jpg,.png"
      >
        <div className="edit-picture">
          <div>{!loadingImage ? <UploadOutlined /> : <LoadingOutlined />}</div>
          {pageDetails.BackgroundImage
            ? "Modifier l'image de fond"
            : "Télécharger une image de fond"}
        </div>
      </Upload>
    </div>
  );
};

export default UploadBackgroundImage;
